import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Receipt } from 'lucide-react';
import { memo } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../utils/testIds/OrderConditions.testIds';
import { useTranslation } from '../../../translation/TranslationContext';

interface OrderInvoicesButtonProps {
  hasInvoices: boolean;
  onClick: () => void;
}

const OrderInvoicesButton = ({ hasInvoices, onClick }: OrderInvoicesButtonProps) => {
  const { translate } = useTranslation();

  return (
    <Tooltip
      disabled={hasInvoices}
      TooltipContent={translate(LangEnum.ORDER_INVOICES_NO_DATA_TOOLTIP)}
    >
      <Button
        variant="contained"
        color="secondary"
        disabled={!hasInvoices}
        startIcon={<Icon icon={Receipt} size="md" />}
        testId={OrderConditionsTestIds.ORDER_INVOICES_BUTTON}
        onClick={onClick}
      >
        {translate(LangEnum.ORDER_INVOICES_BUTTON_LABEL)}
      </Button>
    </Tooltip>
  );
};

export default memo(OrderInvoicesButton);
